
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruit/jobs/[city]/[area]/[jobAdvert]",
      function () {
        return require("private-next-pages/recruit/jobs/[city]/[area]/[jobAdvert].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruit/jobs/[city]/[area]/[jobAdvert]"])
      });
    }
  